@use "../../sass/variables/colors";

:host {
  align-items: center;
  display: flex;
  height: max-content;
  justify-content: center;
  padding: 5px 15px;
  width: 100%;
}

:host([type='info']) {
  background-color: colors.$color-blue-info;
  color: colors.$color-white;
  fill: colors.$color-white;
}

:host([type='error']) {
  border: 1px solid colors.$color-red-error;
  color: colors.$color-red-error;
  fill: colors.$color-red-error;

  ::slotted(ux-copy) {
    color: colors.$color-red-error;
  }
}

ux-icon {
  margin-right: 15px;
}

::slotted(ux-copy) {
  margin-top: 1em;
  margin-bottom: 1em;
  display: inline-block;
  color: colors.$color-white;
}